import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=097cadd6"
import script from "./ChannelCard.vue?vue&type=script&lang=js"
export * from "./ChannelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports